import { render, staticRenderFns } from "./DeviceStatusItem2.vue?vue&type=template&id=6f4cf582&scoped=true"
import script from "./DeviceStatusItem2.vue?vue&type=script&lang=js"
export * from "./DeviceStatusItem2.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatusItem2.vue?vue&type=style&index=0&id=6f4cf582&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cf582",
  null
  
)

export default component.exports